import * as msal from "@azure/msal-browser";
import { NEXT_API_URL2 } from "../Helper/Config";
// import { useRouter } from "next/router";

// const router = useRouter();

const msalConfig = {
    auth: {
      // #for dev
        // clientId: process.env.NEXT_PUBLIC_AZURE_AD_CLIENT_ID,
        // authority: `https://login.microsoftonline.com/bf048976-7110-4e87-96f3-c6744908b8be`,
        // redirectUri: 'https://dev.bizcare.celcom.com.my/',
        // postLogoutRedirectUri:"https://dev.bizcare.celcom.com.my/",

      // #for sit
        // clientId: process.env.NEXT_PUBLIC_AZURE_AD_CLIENT_ID,
        // authority: `https://login.microsoftonline.com/bf048976-7110-4e87-96f3-c6744908b8be`,
        // redirectUri: 'https://sit.bizcare.celcom.com.my/',
        // postLogoutRedirectUri:"https://sit.bizcare.celcom.com.my/"

        // #for all env
      clientId: process.env.NEXT_PUBLIC_AZURE_AD_CLIENT_ID,
      authority: process.env.NEXT_PUBLIC_AUTHORITY,
      redirectUri: process.env.NEXT_PUBLIC_REDIRECTURI,
      postLogoutRedirectUri:process.env.NEXT_PUBLIC_POSTLOGOUTREDIRECTURI

      // #for local
        // clientId: process.env.NEXT_PUBLIC_AZURE_AD_CLIENT_ID,
        //  authority: `https://login.microsoftonline.com/common`,
        //  redirectUri: 'http://localhost:3018/',
        // postLogoutRedirectUri:"http://localhost:3018/",
    } 
    // ,
    //  cache: {
    //    cacheLocation: 'sessionStorage',
    //      storeAuthStateInCookie: false
    // },
    //  system: {
    //     loggerOptions: {
    //     loggerCallback: (level, message, containsPii) => {
    //      if (containsPii) {
    //     return
    //     }
    //    }
    //    }
    //     }
};

let msalLoading = true;

const msalInstance1 = new msal.PublicClientApplication(msalConfig);
// msalInstance1
//       .handleRedirectPromise()
//       .then(async (res) => {
//        // const tokenValue = await res.account;
//        msalLoading = false;
//         if (res != null && res.account != null) {
//           msalInstance1.setActiveAccount(res.account);

//           // encToken = await this.userService.encryptUser(res.idToken);

//           // sessionStorage.setItem('id_token', encToken);
//           if (res.idToken) {
            
//             console.log('inside msal.js', res.idToken);
//             window.sessionStorage.setItem('loginType', 'AD');
//             // router.push({
//             //   pathname: '/Celcom_dashboard',
//             //   query: { id_token: idToken },
//             // });
//             setAdminToken(res.idToken);
//           //  setNoShow(false);
//            // setIsLoading(false);
//             window.location.href = `${NEXT_API_URL2}/bizcareui/api/auth/authAdmin?id_token=${res.idToken}`;
//           }else {
//             console.log("insdie else of msal.js");
//             window.location.href = `${NEXT_API_URL2}/bizcareui`;
//           }
//         }
//       })
//         .catch((err) => {
// 	      //	setNoShow(false);
//         console.log("insdie catch of msal.js");
//         msalLoading = false;
//           console.log(err);
//           window.location.href = `${NEXT_API_URL2}/bizcareui`;

//           //  this.router.navigate(['/login']);
//         });


export { msalInstance1}